import React, { useEffect, useRef, useState } from "react";
import MenuIcon from "../../../images/horizontal-icon.svg";
import DBSIcon from "../../../images/dbs.svg";
import FeaturedIcon from "../../../images/featured.svg";
import EditIcon from "../../../images/edit.svg";
import DeleteIcon from "../../../images/delete.svg";
import InactiveIcon from "../../../images/inactive.svg";
import TimeIcon from "../../../images/time.svg";
import LTVIcon from "../../../images/ltv.svg";
import { useSelector } from "react-redux";
import { getNameFromSettings } from "../../../helpers/utils";
import {
  LOAN_PROVIDER_IMAGE_BASE_URL,
  SETTINGS_APPROVAL_TIME_LIST,
  SETTINGS_LOAN_PROVIDERS_LIST,
  SETTINGS_LTV_LIST,
  SETTINGS_PRODUCT_TYPE_LIST,
} from "../../../helpers/constants";
import MoreIcon from "../../../images/more-horizontal.png";
import { FaCrown } from "react-icons/fa";
import { AiFillStar } from "react-icons/ai";
import {
  Menu,
  MenuItem,
  ThemeProvider,
  alpha,
  createTheme,
  styled,
} from "@mui/material";
import { useCallback } from "react";
import Noimage from "../../../images/noimage.png";


export default function ProviderGridItem(props) {
  const {
    data,
    onFeatureClick,
    onInactiveClick,
    onDeleteClick,
    onEditClick,
    currentTab,
    handleCloseMenu,
    handleOpenMenu,
    menuOpen,
    anchorEl,
    index,
    pagePermission,
  } = props;
  //console.log({ index });
  const settings = useSelector((state) => state.settings);

  const onEdit = useCallback(() => {
    handleCloseMenu(false);
    onEditClick(data);
  }, [data, handleCloseMenu, onEditClick]);

  const onStatusClick = useCallback(() => {
    onInactiveClick(data.id, data.status);
    handleCloseMenu();
  }, [data, onInactiveClick, handleCloseMenu]);

  const onDelete = useCallback(() => {
    onDeleteClick(data.id);
    handleCloseMenu();
  }, [data, onDeleteClick, handleCloseMenu]);

  return (
    <ThemeProvider theme={createTheme()}>
      <div
        id={data.id}
        className="rounded-[16px] bg-white  p-[16px_20px] w-[32%] max-[1300px]:w-[48%] max-[1200px]:w-[48%] max-[700px]:w-[100%] max-w-[100%] cus_shadow2 relative z-0"
      >
        <div className="card_head relative flex justify-between items-center mb-[10px]">
          <div className="absolute top-[-33px] left-0 bg-white h-[58px] w-[58px] rounded-[8px]">
            {/* <img
              src={`${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.icon}`}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ maxWidth: "100%", height: "auto" }}
            /> */}
            <img
              src={
                data?.icon
                  ? `${LOAN_PROVIDER_IMAGE_BASE_URL}/${data.icon}`
                  : Noimage // ✅ Use fallback image if no avatar
              }
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = Noimage; // ✅ Set fallback image on error
              }}
              alt="Bank Logo"
              className="rounded-[8px]"
              width="58"
              height="58"
              style={{ width: "auto", height: "40px", margin: "10px auto" }}
            />
          </div>
          <span className="pl-[70px] flex-fixed font-[700] line-clamp-1">
            {data.name}
          </span>
          {pagePermission?.update_permission == 1 && (
            <div className="py-1 px-2 gap-2">
              <img
                src={MoreIcon}
                className="w-5 cursor-pointer"
                onClick={(e) => handleOpenMenu(index, e)}
                id="fade-button"
              />
              <div className="menu-container ">
                <Menu
                  id="fade-button"
                  MenuListProps={{
                    "aria-labelledby": "demo-customized-button",
                  }}
                  anchorEl={anchorEl}
                  open={menuOpen}
                  onClose={handleCloseMenu}
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.1))",
                      mt: 1,
                      minWidth: "140px",
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1,
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        right: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0,
                      },
                    },
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                >
                  <MenuItem
                    onClick={onEdit}
                    // onClick={() => onEditClick(data)}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={EditIcon} className="h-4 w-4 mr-4" />
                    Edit Provider
                  </MenuItem>
                  <MenuItem
                    onClick={onStatusClick}
                    sx={{
                      fontSize: "12px",
                      fontWeight: 500,
                      fontFamily: '"Inter", sans-serif',
                    }}
                  >
                    <img src={InactiveIcon} className="h-4 w-4 mr-4" />
                    {data.status ? "Inactive" : "Active"}
                  </MenuItem>
                  {currentTab.parameter == "status" &&
                    currentTab.value == 0 &&
                    pagePermission.delete_permission == 1 && (
                      <MenuItem
                        onClick={onDelete}
                        sx={{
                          fontSize: "12px",
                          fontWeight: 500,
                          fontFamily: '"Inter", sans-serif',
                        }}
                      >
                        <img src={DeleteIcon} className="h-4 w-4 mr-4" />
                        Delete
                      </MenuItem>
                    )}
                </Menu>
              </div>
            </div>
          )}
        </div>
        <div className="flex items-center gap-x-2">
          {data?.hasPremium ? (
            <div className="items-center inline-block mb-[8px] p-[1px] px-2 flex text-[12px] font-[500] border border-1 rounded-[4px] z-[-1] ">
              <FaCrown size={23} color="#ffac04" className="pe-2" />
              <p>{`Premium`}</p>
            </div>
          ) : null}
          <div
            onClick={() => onFeatureClick(data.id, data.featured)}
            className={`items-center inline-block mb-[8px] p-[1px] px-2 flex text-[12px] font-[500] border border-1 rounded-[4px] cursor-pointer`}
          >
            <AiFillStar
              size={24}
              color={`${data.featured ? "#ffac04" : "#d3d3d3"}`}
              className={`pe-2`}
            />
            <p>{`Featured`}</p>
          </div>
        </div>
        <div className="flex fex-wrap gap-[15px_30px] pl-[5px] mb-[10px]">
          <div className="flex items-center gap-[10px]">
            <p className="text-[11px] text-gray-500">ID:</p>
            <p className="text-[13px] font-[600] md:text-xs text-black capitalize md:tracking-[-.15px]">
              {data.uniqueId}
            </p>
          </div>
          <div className="flex items-center gap-[10px]">
            <p className="text-[11px] text-gray-500">Type:</p>
            <p className="text-[13px] font-[600] md:text-xs text-black capitalize md:tracking-[-.15px]">
              {getNameFromSettings(
                settings,
                SETTINGS_LOAN_PROVIDERS_LIST,
                data.type
              )}
            </p>
          </div>
        </div>
        <div className="flex flex-wrap items-center justify-between gap-[15px] mb-[5px]">
          <div className="flex gap-[10px]">
            <div className="flex items-center col-span-2">
              <img src={TimeIcon} className="w-3 h-3 mr-1" />
              <p className="text-[13px] md:text-xs text-gray-600 ">
                Approval Time:
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-[13px] md:text-xs text-black font-[600] capitalize md:tracking-[-.15px]">
                {getNameFromSettings(
                  settings,
                  SETTINGS_APPROVAL_TIME_LIST,
                  data.approvalTime
                )}
              </p>
            </div>
          </div>
          <div className="flex gap-[10px]">
            <div className="flex items-center col-span-2">
              <img src={LTVIcon} className="w-3 h-3 mr-1" />
              <p className="text-[13px] md:text-xs text-gray-600">
                Loan to Value:
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-[13px] md:text-xs text-black font-[600] capitalize md:tracking-[-.15px]">
                {getNameFromSettings(settings, SETTINGS_LTV_LIST, data.ltv)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
}
